import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOption } from "../../models/generic";
import { ReactSelectOptionSchema } from "../generic";

export interface ScheduleAbstractsData {
    day: Date | null;
    dayFormatted: string | null;
    existingEvent: ReactSelectOption | null;
    isNewEvent: boolean;
    time: Date | null;
    title: string | null;
    typeId: number | null;
}

export class ScheduleAbstracts implements FormValidationModel<ScheduleAbstractsData> {
    public data: ScheduleAbstractsData;
    public rules: yup.Schema<ScheduleAbstractsData>;

    public constructor() {
        this.data = {
            day: null,
            dayFormatted: null,
            existingEvent: null,
            isNewEvent: true,
            time: null,
            title: "",
            typeId: null,
        };
        this.rules = yup.object<ScheduleAbstractsData>().shape({
            day: yup.date().nullable(true).label("Day").when(["isNewEvent"], (isNewEvent: boolean) => {
                const schema = yup.date().nullable(true).label("Day");
                return isNewEvent ? schema.required() : schema;
            }),
            dayFormatted: yup.string().nullable(true).label("Day").when(["isNewEvent"], (isNewEvent: boolean) => {
                const schema = yup.string().nullable(true).label("Day");
                return isNewEvent ? schema.required() : schema;
            }),
            existingEvent: ReactSelectOptionSchema.label("Event").when(["isNewEvent"], (isNewEvent: boolean) => {
                const schema = ReactSelectOptionSchema.label("Event");
                return isNewEvent ? schema : schema.required();
            }),
            isNewEvent: yup.bool(),
            time: yup.date().nullable(true).label("Time").when(["isNewEvent"], (isNewEvent: boolean) => {
                const schema = yup.date().nullable(true).label("Time");
                return isNewEvent ? schema.required() : schema;
            }),
            title: yup.string().nullable(true).label("Title").when(["isNewEvent"], (isNewEvent: boolean) => {
                const schema = yup.string().nullable(true).label("Title");
                return isNewEvent ? schema.required() : schema;
            }),
            typeId: yup.number().nullable(true).label("Type"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/ScheduleAbstracts.ts